import { createContext, useContext } from "react";

export const PaxContext = createContext({
  passengers: [],
  setPax: () => {},
});
export const usePaxContext = () => useContext(PaxContext);
